import { findReorderTarget } from '../utils/listReorder'

/**
 * Drag-reorder via handle only (mousedown on .cfg-drag-handle).
 * Text in labels/inputs stays selectable when not dragging.
 */
export default {
  data() {
    return {
      cfgDrag: null,
    }
  },
  beforeDestroy() {
    this.endCfgDrag()
  },
  methods: {
    onCfgDragStart(kind, from, e) {
      if (!this.editMode || e.button !== 0) return
      e.stopPropagation()
      this.cfgDrag = { kind, from, over: from, moved: false }
      document.body.classList.add('cfg-is-dragging')
      document.addEventListener('mousemove', this.onCfgDragMove)
      document.addEventListener('mouseup', this.onCfgDragEnd)
    },
    onCfgDragMove(e) {
      if (!this.cfgDrag) return
      this.cfgDrag.moved = true
      const root = this.$refs.container || this.$el
      const over = findReorderTarget(e.clientX, e.clientY, this.cfgDrag.kind, root)
      if (over >= 0) this.cfgDrag.over = over
    },
    onCfgDragEnd() {
      const drag = this.cfgDrag
      this.endCfgDrag()
      if (!drag || !drag.moved || drag.from === drag.over) return
      this.onCfgReorder(drag.kind, drag.from, drag.over)
    },
    endCfgDrag() {
      this.cfgDrag = null
      document.body.classList.remove('cfg-is-dragging')
      document.removeEventListener('mousemove', this.onCfgDragMove)
      document.removeEventListener('mouseup', this.onCfgDragEnd)
    },
    cfgReorderWrapClass(kind, index) {
      if (!this.cfgDrag || this.cfgDrag.kind !== kind) return {}
      return {
        'cfg-reorder-wrap--dragging': this.cfgDrag.from === index,
        'cfg-reorder-wrap--drop': this.cfgDrag.over === index && this.cfgDrag.from !== index,
      }
    },
  },
}
